import { kDriversFirestoreKey as root } from "../constants/keys";
import {
  doc,
  collection,
  limit,
  getDocs,
  orderBy,
  query,
  startAfter,
  where,
  updateDoc,
} from "@firebase/firestore";
import { db } from "../database";
import { createToast, NotificationBadge } from "@kiwicom/orbit-components";

const VerificationStatus = {
  approved: "approved",
  declined: "declined",
  review: "review",
};

Object.freeze(VerificationStatus);

export const fetchDrivers = async (lastVisible) => {
  if (lastVisible === undefined)
    return Promise.reject("there are no drivers left to be approved");

  const ordersQuery = query(
    collection(db, root),
    orderBy("name"),
    where("verified", "==", VerificationStatus.review),
    startAfter(lastVisible),
    limit(5)
  );

  try {
    const querySnapshot = await getDocs(ordersQuery);
    console.table(querySnapshot.docs);
    return querySnapshot.docs;
  } catch (error) {
    console.log(error);
    createToast("Something went wrong while fetching drivers", {
      icon: <NotificationBadge />,
    });
    return Promise.reject("Something went wrong", error);
  }
};

export const approveDriver = async (driverId, associatedPharmacy, level) => {
  const docRef = doc(db, root, driverId);

  try {
    await updateDoc(docRef, {
      verified: VerificationStatus.approved,
      pharmacies: [associatedPharmacy],
      level: level,
    });

    console.log("driver got approved");

    return true;
  } catch (error) {
    console.log(error);
    return Promise.reject("Something went wrong", error);
  }
};

export const rejectDriver = async (driverId, comments) => {
  const docRef = doc(db, root, driverId);

  try {
    await updateDoc(docRef, {
      verified: VerificationStatus.declined,
      "profile.comments": comments,
    });

    console.log("driver got declined");

    return true;
  } catch (error) {
    console.log(error);
    return Promise.reject("Something went wrong", error);
  }
};
